export const FETCH_CREATE_DIARY_DATA = "FETCH_CREATE_DIARY_DATA";
export const FETCH_CREATE_DIARY_DATA_SUCCESS = "FETCH_CREATE_DIARY_DATA_SUCCESS";
export const FETCH_DIARY_OWNERS_LIST_SUCCESS = "FETCH_DIARY_OWNERS_LIST_SUCCESS";
export const FETCH_DIARIES_BY_DATE = "FETCH_DIARIES_BY_DATE";
export const FETCH_DIARIES_BY_DATE_SUCCESS = "FETCH_DIARIES_BY_DATE_SUCCESS";
export const SHOW_DIARY_FORM_LOADER = "SHOW_DIARY_FORM_LOADER";
export const HIDE_DIARY_FORM_LOADER = "HIDE_DIARY_FORM_LOADER";
export const SHOW_DIARY_OWNER_LOADER = "SHOW_DIARY_OWNER_LOADER";
export const HIDE_DIARY_OWNER_LOADER = "HIDE_DIARY_OWNER_LOADER";